<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6035_821)">
<path d="M34.0909 10L44.0909 20L39.0909 20.9091L34.0909 20L33.1818 15L34.0909 10Z" fill="#188038"/>
<path d="M34.0909 20V10H17.7273C16.2205 10 15 11.2205 15 12.7273V47.2727C15 48.7795 16.2205 50 17.7273 50H41.3636C42.8705 50 44.0909 48.7795 44.0909 47.2727V20H34.0909Z" fill="#34A853"/>
<path d="M20.4546 25.4546V38.6364H38.6364V25.4546H20.4546ZM28.4091 36.3636H22.7273V33.1818H28.4091V36.3636ZM28.4091 30.9091H22.7273V27.7273H28.4091V30.9091ZM36.3636 36.3636H30.6818V33.1818H36.3636V36.3636ZM36.3636 30.9091H30.6818V27.7273H36.3636V30.9091Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_6035_821">
<rect width="29.0909" height="40" fill="white" transform="translate(15 10)"/>
</clipPath>
</defs>
</svg>
